import { useApi } from "#hooks/useApi"
import { categoryGet } from "#training/services/Api"
import { TextField } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import { Fragment, useEffect, useMemo, useState } from "react"

const SelectCategory = (props) => {
	const { data, loading } = useApi(categoryGet, { autoFetch: !props.data })
	const { category } = data || { category: [] }
	const useData = useMemo(() => {
		const data = props.data ?? category
		if (props.notEdit) return data.filter((element) => element.is_editable)
		return data
	}, [category, props.data, props.notEdit])
	const [selectedCategory, setSelectedCategory] = useState(null)

	useEffect(() => {
		if (!props?.value) setSelectedCategory(null)
		else
			useData.forEach((element) => {
				if (props.value === element.id) setSelectedCategory(element)
			})
	}, [props.value, useData])

	useEffect(() => {
		if (typeof props.getData === "function") props.getData(useData)
		if (typeof props.getLoading === "function") props.getLoading(loading)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [useData, loading])

	return (
		<Autocomplete
			fullWidth={props.fullWidth}
			style={{ minWidth: props.minWidth }}
			disabled={props.disabled || (!props.data && loading) || useData.length <= 1}
			value={selectedCategory} // El valor seleccionado
			onChange={(event, newValue) => {
				if (typeof props.setValue === "function") props.setValue(newValue?.id)
				if (typeof props.onChange === "function") props.onChange(newValue)
				setSelectedCategory(newValue)
			}}
			options={useData}
			loading={true}
			getOptionLabel={(option) => option?.description}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Categoría"
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						},
					}}
				/>
			)}
		/>
	)
}
export default SelectCategory
